import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from "baseui/modal";

const ShowHiddenPageWarning = () => {
    const [show, setShow] = useState(true);

    return (
        <Modal
            isOpen={show}
            onClose={() => setShow(false)}
            closeable
        >
            <ModalHeader>Deprecated Page</ModalHeader>
            <ModalBody>
                This function is deprecated and will be removed in a future release.
                For any inquiries or migration assistance, please contact Shaharyar Ahmed at [shaharyar.ahmed@turing.com].
            </ModalBody>
        </Modal>
    )
}

export default ShowHiddenPageWarning;